<template>
  <app-base-main no-padding parentTable>
    <!-- 筛选条件 -->
    <template #filter-group>
      <app-filter-group @reset="$gjReset"  @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
          v-model="filter.currency"
          :options="financeCurrencysOption"
          :clearable="false"
        ></gj-select>
        <gj-select-date-picker-active
            :type="filter.date.key === 1 ? 'daterange' : 'monthrange'"
            v-model="filter.date"
            :options="[
              {id: 0, text: '月份'},
              {id: 1, text: '日期'},
            ]"
            :shortcuts="shortcuts"
            @input="changeDatePciker"
            :dateClearable="false"
        >
        </gj-select-date-picker-active>
      </app-filter-group>
    </template>
    <!-- 操作 -->
    <template #operate-group>
      <gj-button type="primary" @click="clickRecalculate">重算</gj-button>
      <gj-button type="default" @click="clickImportOtherExpenses">导入其他费用</gj-button>
      <gj-button type="default" @click="clickExpenseManagementItems">费用管理项</gj-button>
      <!--      <gj-button @click="clickSharing">费用分摊</gj-button>-->
    </template>
    <template #tool-group>
      <profit-report-tool
          :table-columns="columns" :table-name="tableName"
          download-url="/finance/financialProfitAnalysis/exportProfitAnalysis"
          :download-params="globalParams">
      </profit-report-tool>
    </template>
    <template #table>
      <profit-report-table-template
          show-summary :summary-object="dataTotal"
          :data="data"
          adaptParent
          :columns="columns"
          :show-overflow="false"
          :pagination="pagination"
          :loading="loading"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :queryParams="setModel()"
          :customData = "expenseManagementTable"
          :tabsActive = "'market'"
          @refresh="$gjNoticeQuery"
      ></profit-report-table-template>
    </template>
  </app-base-main>
</template>

<script>
  import _ from "lodash";
  import ProfitReportTool from "../tool/profit-report-tool";
  import {financeProfitReport} from '../common/fields';
  import FinanceRecalculate from "modules/common/finance/finance-recalculate-modal";
  import ProfitReportSharing from '../sharing/profit-report-sharing';
  import ProfitReportTableTemplate from "./template/profit-report-table-template";
  import {isMeaningfulMixin, queryMixin} from "../../../../../minxins";
  import {exportProfitAnalysis, getFinanceAnalysisPage, queryFeeItemList, analysisStatistics} from "@/api/finance";
  import ImportOtherExpenses from "@/views/modules/finance/finance-profit-report/modal/import-other-expenses"
  import ExpenseManagementItems from "@/views/modules/finance/finance-profit-report/modal/expense-management-items"
  import { financeCurrencysOption } from "@/utils/options";
  import { startOfMonth, endOfMonth } from "date-fns";
  import {convertToFullDate} from "@/utils/date.util";
  export default {
    name: "finance-profit-report-market",
    components: {ProfitReportTableTemplate, ProfitReportTool},
    mixins: [queryMixin, isMeaningfulMixin],
    inject: ["getFilter", "setFilter"],
    mounted() {
      let filter = this.getFilter()
      this.filter = {...this.filter, ...filter}
    },
    beforeDestroy() {
      this.setFilter(this.filter)
    },
    data() {
      return {
        financeCurrencysOption,
        isInitParams: false,
        useCache: false,
        tableName: 'financeProfitReportMarket_v1.8.0',
        dataTotal: {},
        data: [],
        columns: [
          { id: "marketName", header: "店铺/国家", field: "name", minWidth: "120px", default: true, fixed: 'left', disabled: true, sortable: true},
          ...financeProfitReport
        ],
        filter: {
          countryMarketValue: {},
          currency: '',
          date: {
            key: 0,
            value: new Date()- 3600 * 1000 * 24 * 30,
          }
        },
        expenseManagementTable: [],
        shortcuts: [ '本月', '上月' ],
        dateKey : 0,
        defaultSort:{
          prop:'name,alesAmount,salesMoney',
          order:'descending,descending,descending'
        },
        moduleName: 'FINANCE_PROFIT_REPORT',
        notStorage: true
      }
    },
    watch: {
      "filter.date.key"(val) {
        if (val == 1) {
          this.shortcuts = ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'];
          return;
        }
        this.shortcuts = ['本月', '上月'];
      }
    },
    created() {
      if(this.dateKey !== 1){
        this.queryFeeItemList().then(() => {
          this.$gjNoticeQuery()
        });
      } else {
        this.$gjNoticeQuery()
      }
    },
    methods: {
      // 初始化,重置
      $gjQueryInitParams() {
        return {
          filter: {
            countryMarketValue: {},
            currency: '',
            date: {
              key: 0,
              value: new Date()- 3600 * 1000 * 24 * 30,
            }
          },
        }
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{ countryMarketValue: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryMarketValue: params.countryMarketValue
        };
      },
      // 设置参数model
      setModel() {
        let model = {
          countryIds: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency,// 币种
          dateType: null, startDate: null, endDate: null,// 月份/日期范围
        }
        // 月份/日期范围处理
        model.dateType = String( this.filter.date.key)
        if (this.filter.date.key === 1) {
          model.startDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd');
          model.endDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd');
        } else {
          model.startDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
          model.endDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
        }
        return model
      },
      // 查询
      $gjQuery() {
        const _this =this;
        this.loading = true;
        let model = this.setModel()
        this.globalParams = {
          model,
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams.model.queryType = 'market';
        // 获取合计
        analysisStatistics(this.globalParams).then(data => {
          this.dataTotal = data || {}
          if(this.dataTotal.feeItemList && this.dataTotal.feeItemList.length > 0){
            let feeItemList = this.dataTotal.feeItemList;
            feeItemList.forEach(o =>{
              this.dataTotal[o.feeItemName] = o.feePrice;
            })
          }
        })
        // 获取table数据
        getFinanceAnalysisPage(this.globalParams).then((data) => {
          //自定义费用需要拿出来，放在第一级
          this.data = data.records.map((v,idx)=>{
            if(v.feeItemList && v.feeItemList.length>0){
              let feeItemList = v.feeItemList;
              feeItemList.forEach(o =>{
                v[o.feeItemName] = o.feePrice;
              })
            }
            return v;
          });
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      },
      //查询自定义费用项
      queryFeeItemList(){
        const _this =this;
        //查询自定义费用项
        return queryFeeItemList().then((data)=>{
          let isCustomExist = _.get(_this.columns, `${11}.id`) === 'customFee';
          let others = {
            id: 'customFee',
            header: '自定义费用',
            field: 'slot:customFee',
            align: "center",
            help: '1、如在站点维度添加了数据，则以站点维度添加的数据为准 2、如未在站点维度添加数据，则系统自动汇总MSKU维度添加的数据',
            children: []
          };
          let hashList = [];
          data.forEach((v, idx) => {
            let itemExpenseManagement = {};
            const item = {
              id: `${v.feeItemName}`,
              header: v.feeItemName,
              field: `slot:${v.feeItemName}`,
              minWidth: '150px',
              align: 'right',
              prefix: 'currencySymbol',
              default: true,
              summary: true,
            }
            itemExpenseManagement = {feeItemName: v.feeItemName, canDelete: v.canDelete};
            //后端通过id判断增还是改
            if (v.id) {
              itemExpenseManagement.id = v.id;
            }
            others.children.push(item);
            hashList.push(itemExpenseManagement);
          })
          let list = _.uniqBy(hashList, 'feeItemName');
          this.expenseManagementTable = list.map(v=> v);
          let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
          this.columns.splice(othersIndex + 1, 0, others);
          //去重，防止界面多次调用此方法
          this.columns = _.uniqBy(this.columns, 'id');
          //PS 深拷贝，插入自定义数据后需要重新渲染界面
          this.columns = _.cloneDeep(this.columns);
        })
      },
      clickRecalculate() {
        this.$gjCreate(FinanceRecalculate)
      },
      //导入其他费用
      clickImportOtherExpenses(){
        const _this = this;
        this.$gjCreate(ImportOtherExpenses,{
          props: {
            tabsActive: "market"
          },
          on:{
            importSuccess:(params)=>{
              this.$gjResetPage();
            }
          }
        })
      },
      //费用管理项
      clickExpenseManagementItems(){
        const _this = this;
        this.$gjCreate(ExpenseManagementItems,{
          props: {
            tableData: this.expenseManagementTable,
            tabsActive: "market"
          },
          on:{
            imported:(params)=>{
              this.$gjMessage.success('添加成功');
              this.$gjResetPage();
            },
            cenceled:(params)=>{
              _this.queryFeeItemList().then(() => {
                this.$gjNoticeQuery()
              });
            },
          },
        })
      },
      clickSharing() {
        this.$gjCreate(ProfitReportSharing)
      },
      //修改日期选择方式
      changeDatePciker(date){
        if(date.key === 1){//选择日期，隐藏自定义费用项
          if(!_.isArray(date.value)){
            this.filter.date = {
              key: 1,
              value: [startOfMonth(new Date()- 3600 * 1000 * 24 * 30), endOfMonth(new Date()- 3600 * 1000 * 24 * 30)],
            };
          }
          if(date.key !== this.dateKey){
            let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
            this.columns.splice(othersIndex + 1, 1);
          }
          this.dateKey = 1;
          this.columns = _.cloneDeep(this.columns);
        }else{
          this.filter.date = {key: date.key, value: _.isArray(date.value) ? date.value[0] : (date.value ? date.value : new Date()- 3600 * 1000 * 24 * 30),}
          this.queryFeeItemList().then(() => {
            this.$gjNoticeQuery()
          });
          this.dateKey = 0;
        }
      },
      download() {
        exportProfitAnalysis(this.globalParams);
      },
    }
  }
</script>

<style scoped>

</style>
